import { useMutation } from '@tanstack/react-query';
import notificationsUserApi from 'api/notificationsUserApi';

const useReadAllNotificationsApi = () => {
    return useMutation(() => notificationsUserApi.readAllNotifications());
};

export default useReadAllNotificationsApi;
